import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredCrown = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.276 11.987C14.276 11.7195 14.075 11.5032 13.8274 11.5032H2.22188C1.9743 11.5032 1.7741 11.7195 1.7741 11.987V13.1499C1.7741 13.42 1.9743 13.6364 2.22188 13.6364H13.8274C14.075 13.6364 14.276 13.42 14.276 13.1499V11.987ZM15.3725 5.65892C15.3741 5.70748 15.3725 5.75428 15.361 5.80284L14.3739 10.0675C14.3225 10.2838 14.1443 10.4339 13.9392 10.4356L8.01839 10.4674H8.01593H2.09264C1.88754 10.4674 1.70696 10.3156 1.65793 10.101L0.670854 5.81785C0.659415 5.76929 0.655329 5.71807 0.659415 5.67128C0.276186 5.5406 0 5.15299 0 4.69739C0 4.13672 0.420816 3.68201 0.940503 3.68201C1.46183 3.68201 1.88264 4.13672 1.88264 4.69739C1.88264 5.01525 1.74945 5.29779 1.53945 5.48586L2.77412 6.83147C3.08871 7.1714 3.52096 7.36653 3.96466 7.36653C4.48762 7.36653 4.99014 7.09635 5.30392 6.64605L7.33364 3.73675C7.1645 3.55398 7.05745 3.29881 7.05745 3.01715C7.05745 2.4556 7.48154 2 7.99959 2C8.51928 2 8.94336 2.4556 8.94336 3.01715C8.94336 3.29086 8.84286 3.5372 8.67943 3.72086C8.68189 3.72086 8.68189 3.72262 8.68189 3.72262L10.6985 6.6381C11.0131 7.0937 11.5148 7.36653 12.0411 7.36653C12.488 7.36653 12.9097 7.17846 13.2259 6.83588L14.4695 5.49292C14.2563 5.30486 14.1174 5.0179 14.1174 4.69739C14.1174 4.13672 14.5382 3.68201 15.0603 3.68201C15.58 3.68201 16 4.13672 16 4.69739C16 5.14063 15.7377 5.51941 15.3725 5.65892Z"
      fill="url(#paint0_linear_2950_15951)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2950_15951"
        x1={8}
        y1={2}
        x2={8}
        y2={13.6364}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EBEBEB" />
        <stop offset={1} stopColor="#4E4B52" />
      </linearGradient>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColouredCrown)
const IconSvgColouredCrown = createIcon(ForwardRef, 'SvgColouredCrown')
export default IconSvgColouredCrown
